import _toConsumableArray from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/var/www/extraise.com/client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/var/www/extraise.com/client/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _defineProperty from "@babel/runtime/helpers/defineProperty"; ///////////////////////////////////////////////////////////
// ReflexElement
// By Philippe Leefsma
// December 2016
//
///////////////////////////////////////////////////////////

import ReflexHandle from './ReflexHandle';
import { getDataProps } from './utilities';
import throttle from 'lodash.throttle';
import Measure from 'react-measure';
import PropTypes from 'prop-types';
import React from 'react';

var toArray = function toArray(obj) {
  return obj ? Array.isArray(obj) ? obj : [obj] : [];
};

var SizeAwareReflexElement = /*#__PURE__*/function (_React$Component) {
  _inherits(SizeAwareReflexElement, _React$Component);

  var _super = _createSuper(SizeAwareReflexElement);

  function SizeAwareReflexElement(props) {
    var _this;

    _classCallCheck(this, SizeAwareReflexElement);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onResize", function (rect) {
      var _this$props = _this.props,
          resizeHeight = _this$props.resizeHeight,
          resizeWidth = _this$props.resizeWidth;
      var _rect$bounds = rect.bounds,
          height = _rect$bounds.height,
          width = _rect$bounds.width;

      _this.setDimensions(_objectSpread({}, resizeHeight && {
        height: height
      }, resizeWidth && {
        width: width
      }));
    });

    _this.setDimensions = throttle(function (dimensions) {
      _this.setState(dimensions);
    }, _this.props.propagateDimensionsRate / 1000);
    _this.state = {
      height: "100%",
      width: "100%"
    };
    return _this;
  }

  _createClass(SizeAwareReflexElement, [{
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      var propagateDimensions = this.props.propagateDimensions;
      var validChildren = toArray(this.props.children).filter(function (child) {
        return !!child;
      });
      return React.Children.map(validChildren, function (child) {
        if (_this2.props.withHandle || ReflexHandle.isA(child)) {
          return React.cloneElement(child, _objectSpread({
            dimensions: propagateDimensions && _this2.state
          }, child.props, {
            index: _this2.props.index - 1,
            events: _this2.props.events
          }));
        }

        if (propagateDimensions) {
          return React.cloneElement(child, _objectSpread({}, child.props, {
            dimensions: _this2.state
          }));
        }

        return child;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement(Measure, {
        bounds: true,
        onResize: this.onResize
      }, function (_ref) {
        var measureRef = _ref.measureRef;
        return React.createElement("div", {
          ref: measureRef,
          className: "reflex-size-aware"
        }, React.createElement("div", {
          style: _this3.state
        }, _this3.renderChildren()));
      });
    }
  }]);

  return SizeAwareReflexElement;
}(React.Component);

var ReflexElement = /*#__PURE__*/function (_React$Component2) {
  _inherits(ReflexElement, _React$Component2);

  var _super2 = _createSuper(ReflexElement);

  function ReflexElement(props) {
    var _this4;

    _classCallCheck(this, ReflexElement);

    _this4 = _super2.call(this, props);
    _this4.state = {
      size: props.size
    };
    return _this4;
  }

  _createClass(ReflexElement, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(prevProps, prevState, snapshot) {
        var directions, _iterator, _step, direction;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(prevState.size !== this.state.size)) {
                  _context.next = 19;
                  break;
                }

                directions = toArray(this.props.direction);
                _iterator = _createForOfIteratorHelper(directions);
                _context.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 11;
                  break;
                }

                direction = _step.value;
                _context.next = 9;
                return this.props.events.emit('element.size', {
                  index: this.props.index,
                  size: this.props.size,
                  direction: direction
                });

              case 9:
                _context.next = 5;
                break;

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);

                _iterator.e(_context.t0);

              case 16:
                _context.prev = 16;

                _iterator.f();

                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 13, 16, 19]]);
      }));

      function componentDidUpdate(_x, _x2, _x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this5 = this;

      var validChildren = toArray(this.props.children).filter(function (child) {
        return !!child;
      });
      return React.Children.map(validChildren, function (child) {
        if (_this5.props.withHandle || ReflexHandle.isA(child)) {
          return React.cloneElement(child, _objectSpread({}, child.props, {
            index: _this5.props.index - 1,
            events: _this5.props.events
          }));
        }

        return child;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = [].concat(_toConsumableArray(this.props.className.split(' ')), [this.props.orientation, 'reflex-element']).join(' ').trim();

      var style = _objectSpread({}, this.props.style, {
        flexGrow: this.props.flex,
        flexShrink: 1,
        flexBasis: '0%'
      });

      return React.createElement("div", _extends({}, getDataProps(this.props), {
        ref: this.props.innerRef,
        className: className,
        style: style
      }), this.props.propagateDimensions ? React.createElement(SizeAwareReflexElement, this.props) : this.renderChildren());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.size !== prevState.size) {
        return _objectSpread({}, prevState, {
          size: nextProps.size
        });
      }

      return null;
    }
  }]);

  return ReflexElement;
}(React.Component);

_defineProperty(ReflexElement, "propTypes", {
  renderOnResizeRate: PropTypes.number,
  propagateDimensions: PropTypes.bool,
  resizeHeight: PropTypes.bool,
  resizeWidth: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.number
});

_defineProperty(ReflexElement, "defaultProps", {
  propagateDimensionsRate: 100,
  propagateDimensions: false,
  resizeHeight: true,
  resizeWidth: true,
  direction: [1],
  className: ''
});

export default React.forwardRef(function (props, ref) {
  return React.createElement(ReflexElement, _extends({
    innerRef: ref
  }, props));
});